import React from "react";
import PropTypes from "prop-types";
import { colors } from "style";
import Tooltip from "components/Tooltip";

/**
 * MissionAccomplished1
 *
 * @param {String}   fill
 */
const MissionAccomplished1 = ({ fill, ...props }) => (
  <Tooltip tooltipId={"Badges.MissionAccomplished1"} hideIcon>
    <svg viewBox="0 0 145 137" fill="none" {...props}>
      <path
        d="M87.7557 13.4853L131.822 45.5015C138.832 50.5944 141.765 59.6218 139.088 67.8622L122.256 119.666C119.578 127.906 111.899 133.485 103.235 133.485H48.7654C40.1008 133.485 32.4217 127.906 29.7442 119.666L12.9123 67.8623C10.2348 59.6218 13.1679 50.5944 20.1777 45.5016L64.2443 13.4853C71.254 8.39242 80.746 8.39241 87.7557 13.4853Z"
        stroke={fill || colors.purpleRainDark1}
        stroke-width="8"
      />
      <path
        d="M58.1944 37H92.8056C96.9002 37 100.238 40.3637 100.083 44.4371C100.052 45.2703 100.021 46.0727 99.975 46.875H116.292C118.347 46.875 120 48.526 120 50.5781C120 64.866 114.824 74.8027 107.886 81.5455C101.041 88.1957 92.6974 91.5439 86.5323 93.2412C82.9012 94.2287 80.4444 97.2529 80.4444 100.277C80.4444 103.502 83.0712 106.125 86.3005 106.125H90.3333C93.0682 106.125 95.2778 108.331 95.2778 111.062C95.2778 113.794 93.0682 116 90.3333 116H60.6667C57.9318 116 55.7222 113.794 55.7222 111.062C55.7222 108.331 57.9318 106.125 60.6667 106.125H64.6995C67.9288 106.125 70.5556 103.502 70.5556 100.277C70.5556 97.2529 68.0833 94.2441 64.4677 93.2412C58.3181 91.5439 49.9743 88.1957 43.1293 81.5455C36.1762 74.8027 31 64.866 31 50.5781C31 48.526 32.6533 46.875 34.7083 46.875H51.025C50.9786 46.0727 50.9477 45.2549 50.9168 44.4371C50.7623 40.3637 54.0998 37 58.1944 37ZM51.5967 54.2812H38.5712C39.3438 64.5111 43.3611 71.4391 48.3056 76.2377C51.7667 79.6014 55.7686 81.993 59.616 83.6902C56.1085 77.4721 53.0028 68.1834 51.5967 54.2812ZM91.3995 83.6902C95.2469 81.993 99.2488 79.6014 102.71 76.2377H102.725C107.654 71.4391 111.672 64.5111 112.46 54.2812H99.4188C98.0127 68.1834 94.9069 77.4721 91.3995 83.6902ZM79.8145 79V49.1816H74.6465L70.9346 51.2734V56.7695L74.7285 54.9854V79H79.8145Z"
        fill={fill || colors.purpleRainDark1}
      />
    </svg>
  </Tooltip>
);

MissionAccomplished1.propTypes = {
  fill: PropTypes.string,
};

export default MissionAccomplished1;
